enum RepairStatus {
  PENDING = 'PENDING',
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
}

export { RepairStatus };
